import _ from 'lodash';

const getReferralCode = () => {
  return window.sessionStorage.getItem('referralCode');
};

const setReferralCode = (referralCode) => {
  window.sessionStorage.setItem('referralCode', referralCode);
};

const getShowAppDownloadPopup = () => {
  const showAppDownloadPopup = window.sessionStorage.getItem(
    'showAppDownloadPopup'
  );
  if (_.isEmpty(showAppDownloadPopup)) {
    return true;
  }
  return showAppDownloadPopup === 'true';
};

const setShowAppDownloadPopup = (show) => {
  window.sessionStorage.setItem('showAppDownloadPopup', show);
};

const getShowAppDownloadBanner = () => {
  const showAppDownloadBanner = window.sessionStorage.getItem(
    'showAppDownloadBanner'
  );
  if (_.isEmpty(showAppDownloadBanner)) {
    return true;
  }
  return showAppDownloadBanner === 'true';
};

const setShowAppDownloadBanner = (show) => {
  window.sessionStorage.setItem('showAppDownloadBanner', show);
};

export default {
  setReferralCode,
  getReferralCode,
  getShowAppDownloadPopup,
  setShowAppDownloadPopup,
  getShowAppDownloadBanner,
  setShowAppDownloadBanner,
};
